export default __webpack_public_path__ + "static/media/books2-afterA-480w.151d7202.webp";